import { Alert } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkButtonDetails from 'src/components/LinkButtonDetails/LinkButtonDetails';
import { formatOrganizationNumber } from 'src/utils/format';

export type InvalidMember = {
  name: string;
  organizationNumber: string;
  rowNumber: number;
  reason: string;
};

type Props = {
  items: InvalidMember[];
};

const ImportMembersInvalidMessage: React.FC<Props> = ({ items }) => {
  const { t: tCommon } = useTranslation();
  const { t: tResourceBase } = useTranslation('resourceBase');

  if (items.length === 0) {
    return null;
  }

  return (
    <Alert data-color="danger" className="margin-bottom--3">
      <p>{tResourceBase('import.invalidOrganizationNumber.description')}</p>

      <LinkButtonDetails text={tCommon('showDetails.show')}>
        <ul>
          {items.map(({ name, organizationNumber, rowNumber, reason }, index) => (
            <li key={index}>
              {name} ({formatOrganizationNumber(organizationNumber)}) - <em>{reason}</em> ({tCommon('row')}:{' '}
              {rowNumber})
            </li>
          ))}
        </ul>
      </LinkButtonDetails>
    </Alert>
  );
};

export default ImportMembersInvalidMessage;
